import { Radio as AntRadio, type RadioGroupProps as AntdRadioButtonGroupProps } from "antd/es";
import React from "react";
import "./RadioButton.css";

interface RadioButtonGroupProps<TValue> extends Omit<AntdRadioButtonGroupProps, "value" | "onChange"> {
	value: TValue;
	onChange: (value: TValue) => void;
}

export const RadioButtonGroup = <TValue,>({
	onChange,
	...props
}: RadioButtonGroupProps<TValue>): ReturnType<React.FC> => (
	<AntRadio.Group
		onChange={(event) => {
			onChange(event.target.value as TValue);
		}}
		{...props}
	/>
);

export const RadioButton: React.FC<React.ComponentProps<typeof AntRadio.Button>> = (props) => (
	<AntRadio.Button {...props} />
);
